import commonActions from './common';
import djiActions from './dji';
import mavlinkActions from './mavlink';

// 공통 actions를 직접 export
export const {
  reset,
  setSpecs,
  changeName,
  load,
  setCollisions,
  setElevations,
  insertWaypoint,
  moveWaypoint,
  editWaypoint,
  editAllWaypoints,
  appendSurvey,
  editSurvey,
  appendGripper,
  appendSetRelay,
  appendCycleRelay,
  appendSetServo,
  appendCycleServo,
  appendDelayUntil,
  appendJumpToItem,
  appendChangeAltitude,
  appendChangeSpeed,
  editChangeSpeed,
  appendWaitForDistance,
  appendWaitForYaw,
  appendTriggerParachute,
  appendGuidedEnable,
  appendGuidedLimits,
  appendAutotuneEnable,
  appendSetRoiNone,
  appendReturnToLaunch,
  resetCommands,
  removeCommand,
  shiftCommand,
  updateCommand,
  changeCommandType,
  addFence,
  editFence,
  removeFence,
} = commonActions;

// 프로토콜별 namespaces
export const mavlink = mavlinkActions;
export const dji = djiActions;

// 하위 호환성을 위해 default export도 제공
const missionActions = {
  ...commonActions,
  mavlink: mavlinkActions,
  dji: djiActions,
};

export default missionActions;
